import LayerGroup from 'ol/layer/Group';
import ImageLayer from 'ol/layer/Image';
import { ImageWMS } from 'ol/source';
import React, { ReactElement, useEffect, useState } from 'react'
import { useAllWeatherContext } from '../../provider/AllWeatherProvider';
import { getGlobalLayer, LocationMarkerPopup } from '../MainWindow';
import { ecmf3hEnd, ecmf3hInterval, ecmf3hStart, ecmf6hEnd, ecmf6hInterval, ecmf6hStart, icon1hInterval,
  icon1hStart, layerStartDate } from '../../TimeLine/BackgroundMapTimeLine/TimeLineService';
import { ecmf, ICON } from '../weather/weatherLayer';
import { map } from '../MainLayer';

type StormSurgesPropsType = {
    name: string;
    color?: string;
    img?: ReactElement<any, any>;
    timeLineHour: string;
    timeLineDate: string;
    selectModel: string;
}

type LayerMapType = Map<string, ImageLayer<ImageWMS>>;
let layerMap: LayerMapType = new Map();

let isButtonClicked: boolean = false;
let stormSurgesMap: Map<string, ImageLayer<ImageWMS>> = new Map();
let stormSurgesIcon: Map<string, ImageLayer<ImageWMS>> = new Map();
let stormSurgesMapECMWF: Map<string, LayerMapType> = new Map();
let stormSurgesMapICON: Map<string, LayerMapType> = new Map();
let receivedLayer: string = "";
export let stormSurgesLayerGroup = new LayerGroup({});

const StormSurges = (props: StormSurgesPropsType) => {
    const {setStormSurges,stormSurges}=useAllWeatherContext();
    const [isSelected, setIsSelected] = useState<boolean>(false)

    const handleButtonClick = () => {
      isButtonClicked = false;
       // setIsSelected(prevState => !prevState)
        // LocationMarkerPopup("StormSurges");
        // if(!isSelected){
        //     setStormSurges("StormSurges")
        // }else{
        //     setStormSurges("StormSurgesNot")
        // }
    }

    useEffect(() => {stormSurgesIconClick();}, [isSelected]);
    
    useEffect(() => {}, [isButtonClicked]);

    useEffect(() => {
        if (stormSurges === "StormSurges") {
          isButtonClicked = true;
          stormSurgesIconClick();
        }
      }, [props.timeLineHour, props.timeLineDate]);

      function formatTimestamp(timestamp: number): string {
        const date = new Date(timestamp * 1000); // Multiply by 1000 to convert to milliseconds
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");
        const hour = String(date.getHours()).padStart(2, "0");
        const minute = String(date.getMinutes()).padStart(2, "0");
    
        return `${year}-${month}-${day}-${hour}:${minute}`;
      }
    
      function parseDateString(dateString: string): string | null {
        const offsetMinutes = new Date().getTimezoneOffset();
    
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})-(\d{2}):(\d{2})$/;
        const match = dateString.match(dateRegex);
        if (!match) {
          console.error("Invalid date format:", dateString);
          return null;
        }
        const [, year, month, day, hour, minute] = match;
        const date = new Date(
          Number(year),
          Number(month) - 1,
          Number(day),
          Number(hour),
          Number(minute)
        );
        date.setMinutes(date.getMinutes() + offsetMinutes);
        const formattedDate = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}-${String(
          date.getHours()
        ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        return formattedDate;
      }
    
      const [isReady, setIsReady] = useState(false);
    
      useEffect(() => {
        if (ecmf6hStart && ecmf6hStart !== 0) {
          setIsReady(true); // Set ready state to true when ecmf6hStart is valid
        }
      }, [ecmf6hStart]);

      const date = new Date();
      const formattedDate = date.toLocaleDateString('en-CA');
    
      const resultMap = new Map<number, string>();
    
      useEffect(() => {
        if (!isReady) return;
        if (stormSurges === "StormSurges") {
      
          let i = 0;
          for (; i <= 48; i++) {
            const value = ecmf3hStart + i * ecmf3hInterval;
            if (value > ecmf3hEnd) break;
            resultMap.set(i, formatTimestamp(value));
          }
    
          for (let j = i; j <= 64; j++) {
            const value = ecmf6hStart + (j - 48) * ecmf6hInterval;
            if (value > ecmf6hEnd) break;
            resultMap.set(j, formatTimestamp(value));
          }
    
          try {
            for (let i = 0; i <= ecmf.size; i++) {
              let dateBefore = resultMap.get(i) ?? "";
              let dayPass = parseDateString(dateBefore);
    
              var layers = new ImageLayer({
                source: new ImageWMS({
                  url: "https://wms.tecxal.com/visura/weatherwmseagle",
                  params: {
                    LAYERS: `weather:${layerStartDate}_ecmwf_${dayPass}:00_temp`,
                    STYLES: "weather:temp",
                  },
                  serverType: "geoserver",
                  projection: "EPSG:4326",
                }),
              });
              layers.set("name", "StormSurges");
              const key = resultMap.get(i);
              if (key !== undefined) {
                stormSurgesMap.set(key, layers);
              }
              stormSurgeMap("StormSurges", stormSurgesMap);
            }
          } catch (error) {
            console.error("Error fetching API data:", error);
          }
        } 
       // else if (weatherlayerState === "flood") {
        //   setIsClicked(false);
        //   LocationMarkerPopup("temperature");
        // } else {
        //   setIsClicked(false);
        // }
      }, [stormSurges, isReady]);

      const [isIconReady, setIconReady] = useState(false);
    
   useEffect(() => {
        if (icon1hStart && icon1hStart !== 0) {
          setIconReady(true);
        }
      }, [icon1hStart]);
    
   const resultIconMap = new Map<number, string>();
    
      useEffect(() => {
        if (!isIconReady) return;
        if (props.selectModel === "ICON") {
          let i = 0;
          for (; i <= 180; i++) {
             const value = icon1hStart + i * icon1hInterval;
            resultIconMap.set(i, formatTimestamp(value));
          }
    
          try {
            for (let i = 0; i <= ICON.size; i++) {
              let dateBefore = resultIconMap.get(i) ?? "";
              let dayPass = parseDateString(dateBefore);
              var layers = new ImageLayer({
                source: new ImageWMS({
                  url: "https://wms.tecxal.com/visura/weatherwmseagle",
                  params: {
                    LAYERS: `weather:2024-11-04_ecmwf_${dayPass}:00_temp`,
                    STYLES: "weather:temp",
                  },
                  serverType: "geoserver",
                  projection: "EPSG:4326",
                }),
              });
              layers.set("name", "StormSurges");
              const key = resultIconMap.get(i);
              if (key !== undefined) {
                stormSurgesIcon.set(key, layers);
              }
              stormSurgeMapICON("StormSurges", stormSurgesIcon);
            }
          } catch (error) {
            console.error("Error fetching API data:", error);
          }
        }
      }, [props.selectModel, isIconReady]);
    
      const stormSurgesIconClick = () => {
        try {
          setTimeout(() => {
            let tempLayerMap;
            if (props.selectModel === "ECMWF") {
              tempLayerMap = stormSurgesMapECMWF.get("StormSurges");
            } else if (props.selectModel === "ICON") {
              tempLayerMap = stormSurgesMapICON.get("StormSurges");
            }
    
            if (tempLayerMap) {
              const layer = tempLayerMap.get(props.timeLineDate + "-" + props.timeLineHour);
              if (layer) {
                getGlobalLayer(layer);
                if (!isButtonClicked) {
                    // addExtremeWeatherLayerGroup(layer, isSelected, "Atmospheric Rivers");
                    stormSurgesLayer(layer, isSelected, "StormSurges");
                } else {
                   // addExtremeWeatherLayerGroup(layer, false, "Atmospheric Rivers");
                   stormSurgesLayer(layer, isSelected, "StormSurges");
                }
              }
            }
            // setWeatherLayer("temperature");
          }, 500);
        } catch (error) {
          console.error("Error fetching API data:", error);
        }
      };


    return (
        <div className={`subItemWrapper`} onClick={(e) => handleButtonClick()} onTouchStart={(e) => handleButtonClick()}>
            {props.color && (
                <div className={`colorBox ${isSelected ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
            )}

            {props.img  && (
                <div className={`colorBox ${isSelected ? 'selected' : ''}`}>
                    {props.img}
                </div>
            )}
            <span>{props.name}</span>
            <div className={`hover-message`}>In progress</div>
        </div>
    )
}

export default StormSurges;

export function stormSurgeMap(weatherLayerName:string,layerMap:LayerMapType){
    stormSurgesMapECMWF.set(weatherLayerName,layerMap);
}

export function stormSurgeMapICON(
    weatherLayerName: string,
    layerMap: LayerMapType
  ) {
    stormSurgesMapICON.set(weatherLayerName, layerMap);
  }
  

export  function stormSurgesLayer (
    receivedWeatherLayer:  ImageLayer<ImageWMS>,
    isRemove: boolean,
    layerName: string
  ): LayerGroup {
    if (isRemove) {
      if (receivedLayer === layerName) {
        stormSurgesLayerGroup.getLayers().clear();
      } else {
        stormSurgesLayerGroup.getLayers().clear();
      }
      stormSurgesLayerGroup.getLayers().push(receivedWeatherLayer);
    //   setLayersvalue(layerName);
    //   getLayerName(layerName, true);
      receivedLayer = layerName;
    } else {
        stormSurgesLayerGroup.getLayers().forEach(function (layer) {
        if (layer.get("name") != undefined && layer.get("name") === layerName) {
            stormSurgesLayerGroup.getLayers().remove(layer);
            stormSurgesLayerGroup.getLayers().clear();
        }
      });
    //   getLayerName(layerName, false);
    }
    return stormSurgesLayerGroup;
  }

  map.addLayer(stormSurgesLayerGroup);